import { css, type Styles } from '@repo/pandacss/styled-system/css';

const encodedArrow = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.49937 9.6262L0.960938 2.0878L2.19937 0.849365L8.49937 7.14937L14.7994 0.849365L16.0378 2.0878L8.49937 9.6262Z"
      fill="#64666A"
    />
  </svg>`)}`;

const labelBase = {
  display: 'block',
  color: 'black',
  marginBottom: '1',
} satisfies Styles;

export const labelBaseClass = css(labelBase);

const selectBase = {
  WebkitAppearance: 'none',
  appearance: 'none',
  backgroundColor: 'white',
  outline: 'none',
  backgroundImage: `url("${encodedArrow}")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 16px center',
  fontFamily: '[inherit]',
  borderWidth: 'thin',
  borderStyle: 'solid',
  borderColor: 'neutral.light',
  borderRadius: '2',
  cursor: 'pointer',
  height: '11',
  minWidth: '[136px]',
  width: 'full',
  paddingY: '2',
  paddingLeft: '4',
  _hover: {
    backgroundColor: 'neutral.lightest',
  },
  _focus: {
    outline: 'none',
    borderColor: 'blue.light',
    boxShadow: '[0 0 0 0.05rem {colors.blue.light}]',
    backgroundColor: 'blue.lightest',
  },
  _disabled: {
    opacity: '0.5',
    cursor: 'not-allowed',
    _hover: {
      backgroundColor: 'white',
    },
  },
} satisfies Styles;
export const selectBaseClass = css(selectBase);

const containerBase = {
  width: { base: 'full', sm: 'auto' },
} satisfies Styles;

export const containerBaseClass = css(containerBase);

export const sortBySelectClass = css(selectBase, {
  borderTopLeftRadius: '[4rem]',
  borderTopRightRadius: '[4rem]',
  borderBottomRightRadius: '[4rem]',
  borderBottomLeftRadius: '[4rem]',
});
export const locationSelectClass = css(selectBase, {
  borderTopLeftRadius: '[4rem]',
  borderTopRightRadius: '[4rem]',
  borderBottomRightRadius: '[4rem]',
  borderBottomLeftRadius: '[4rem]',
});
